/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { uuid } from './uuid';

/**
 * A short summary of a Certificate
 */
export type CertificateSummary = {
	id: uuid;
	/**
	 * The date of issue for the Certificate
	 */
	issuedDate?: string;
	/**
	 * The Meter Case Code value
	 */
	meterCaseCode: string;
	/**
	 * The name of the client.The name field from the Client table.
	 */
	clientName?: string;

	inspectionOutcome?: CertificateSummary.inspectionOutcome;

	reasonForInspection: CertificateSummary.reasonForInspection;

	serialNumber?: string;
	/**
	 * The make of the device
	 */
	make?: string;
	/**
	 * The model of the device
	 */
	model?: string;
	/**
	 * A description of the type of the device
	 */
	mdType?: string;

	/**
	 * The status of the Certificate
	 */
	status?: CertificateSummary.status;
	createdDate: Date;
	creator: uuid;
	newCreatedCertificates?: CertificateSummary[];
};
export namespace CertificateSummary {
	/**
	 * The status of the Certificate
	 */
	export enum status {
		AWAITING_INFORMATION = 'Awaiting Information',
		IN_PROGRESS = 'In Progress',
		SUBMITTED = 'Submitted',
		CANCELLED = 'Cancelled',
	}
	export enum inspectionOutcome {
		CERTIFICATE = 'Certificate',
		NOTICE_WITH_MODIFICATIONS = 'Notice With Modifications',
		NOTICE = 'Notice',
	}
	export enum reasonForInspection {
		NEW_METER = 'New Meter',
		REVALIDATION = 'Revalidation',
		REPLACEMENT = 'Replacement',
	}
}
